import React, { useEffect, useRef, useState } from 'react';
import { Stack, Typography, Card, Box, Divider } from '@mui/material';
import BasicInstitutionForm from './BasicInstitutionForm';
import FloqImageUploader from '../../../components/FloqImageUploader/';
import { useFormik } from 'formik';
import {
    useInstitutionProposalsStore,
    useProposalByInstitutionId,
} from '../../../stores/InstitutionProposalStore';
import { useHistory, useParams } from 'react-router-dom';
import { useInstitutionProposalTabsStore } from '../stores/InstitutionProposalTabsStore';
import { updateInstitutionProposalData } from '../../../services/api/eureka';
const init = {
    name: '',
    subNameList: '',
    image: '',
    imageUrl: '',
    orderingName: '',
    type: '',
    subNameDetail: '',
    info: '',
    cardImageUrl: '',
    backgroundImageUrl: '',
    bannerImageUrl: '',
};

const setFormikValues = data => ({
    name: data?.name || '',
    subNameList: data?.subNameList || '',
    image: data?.image || '',
    imageUrl: data?.imageUrl || '',
    orderingName: data?.orderingName || '',
    subNameDetail: data?.subNameDetail || '',
    info: data?.info || '',
    cardImageUrl: data?.cardImageUrl || '',
    backgroundImageUrl: data?.backgroundImageUrl || '',
    bannerImageUrl: data?.bannerImageUrl || '',
});

const InstitutionInfoTab = () => {
    const history = useHistory();
    const { institutionId } = useParams();

    const proposal = useProposalByInstitutionId(institutionId);
    const fetchProposals = useInstitutionProposalsStore(state => state.fetchProposals);
    const setSubmitButtonOnClick = useInstitutionProposalTabsStore(
        state => state.setOnSubmitButtonClick,
    );
    const setSubmitButtonLoading = useInstitutionProposalTabsStore(
        state => state.setSubmitButtonLoading,
    );

    const [loading, setLoading] = useState(false);
    const dirty = useRef({});

    useEffect(() => {
        if (!institutionId) {
            history.goBack();
        }
        fetchProposals();
    }, [institutionId]);

    useEffect(() => {
        if (proposal) {
            formik.setValues(setFormikValues(proposal.data));
        }
    }, [proposal]);

    const makeDirty = key => {
        dirty.current[key] = true;
    };

    const formik = useFormik({
        initialValues: init,
        validateOnChange: false,
        validateOnBlur: true,
        validate: values => {
            const errors = {};
            if (!values.name) {
                errors.name = 'Enter full name';
            }

            return errors;
        },
        onSubmit: async values => {
            console.log('LOGGER onSubmit');
            setLoading(true);
            setSubmitButtonLoading(true);
            const saveData = {};

            Object.keys(dirty.current).forEach(key => {
                if (dirty.current[key]) {
                    saveData[key] = values[key];
                }
            });

            try {
                await updateInstitutionProposalData(proposal.id, saveData);
            } catch (error) {
                console.error('Error updating institution:', error);
            } finally {
                setLoading(false);
                setSubmitButtonLoading(false);
            }
        },
    });

    useEffect(() => {
        setSubmitButtonOnClick(formik.handleSubmit);
    }, [formik.handleSubmit, setSubmitButtonOnClick]);

    return (
        <Stack spacing={3} maxWidth={1440} marginX="auto">
            <Card sx={{ boxShadow: 2 }}>
                <Stack>
                    <Typography variant="h3" marginBottom={0} paddingY={2} paddingX={3}>
                        General
                    </Typography>
                    <Divider />
                    <Box padding={3}>
                        <BasicInstitutionForm formik={formik} makeDirty={makeDirty} />
                    </Box>
                </Stack>
            </Card>
            <Card sx={{ boxShadow: 2, position: 'relative', overflow: 'visible' }}>
                <Stack>
                    <Typography variant="h3" marginBottom={0} paddingY={2} paddingX={3}>
                        Layout
                    </Typography>
                    <Divider />
                    <Box padding={3}>
                        <Typography variant="h4">Card image</Typography>
                        <Stack width={'393px'} height={'196px'} marginBottom={'24px'}>
                            <FloqImageUploader
                                label="Card image"
                                tag="institution-proposal"
                                maxMB={2}
                                initialFrameHeight={196}
                                imageUrl={formik.values.cardImageUrl}
                                outputDimensions={{ x: 1200, y: 600 }}
                                onChange={images => {
                                    if (images.length && images[0].imageUrl && images[0]._id) {
                                        formik.setFieldValue('cardImage', images[0]._id);
                                    } else {
                                        formik.setFieldValue('cardImage', '');
                                    }
                                    makeDirty('cardImage');
                                }}
                            ></FloqImageUploader>
                        </Stack>
                    </Box>
                    <Divider />
                    <Box padding={3}>
                        <Typography variant="h4">Side panel background</Typography>
                        <Stack width={'393px'} height={'196px'} marginBottom={'24px'}>
                            <FloqImageUploader
                                label="Side panel background"
                                tag="institution-proposal"
                                maxMB={2}
                                initialFrameHeight={196}
                                imageUrl={formik.values.backgroundImageUrl}
                                outputDimensions={{ x: 1200, y: 600 }}
                                onChange={images => {
                                    if (images.length && images[0].imageUrl && images[0]._id) {
                                        formik.setFieldValue('backgroundImage', images[0]._id);
                                    } else {
                                        formik.setFieldValue('backgroundImage', '');
                                    }
                                    makeDirty('backgroundImage');
                                }}
                            ></FloqImageUploader>
                        </Stack>
                    </Box>
                    <Box padding={3}>
                        <Typography variant="h4">Page banner</Typography>
                        <Stack width={'393px'} height={'78px'} marginBottom={'24px'}>
                            <FloqImageUploader
                                label="Page banner"
                                tag="institution-proposal"
                                maxMB={2}
                                initialFrameHeight={78}
                                hideInputIcon
                                imageUrl={formik.values.bannerImageUrl}
                                outputDimensions={{ x: 1920, y: 384 }}
                                onChange={images => {
                                    if (images.length && images[0].imageUrl && images[0]._id) {
                                        formik.setFieldValue('bannerImage', images[0]._id);
                                    } else {
                                        formik.setFieldValue('bannerImage', '');
                                    }
                                    makeDirty('bannerImage');
                                }}
                            ></FloqImageUploader>
                        </Stack>
                    </Box>
                </Stack>
            </Card>
        </Stack>
    );
};

export default InstitutionInfoTab;
